import { ImageUploadImageModel } from "./image-upload-image.model";

export class ImageUploadImageSetModel {
  id: string;
  captionName: string;
  line: string;
  class: string;
  modelNumber: string;
  identifier: string;
  isProductModel: boolean;
  highresimage: ImageUploadImageModel;
  desktoplargeimage: ImageUploadImageModel;
  desktopsmallimage: ImageUploadImageModel; 
  tabletimage: ImageUploadImageModel; 
  phoneimage: ImageUploadImageModel;
  deskLargeResize: boolean;
  deskSmallResize: boolean; 
  tabletResize: boolean;
  phoneResize: boolean;
  constructor(data?) {
    const imageSetData = data || {};
    this.id = imageSetData.id;
    this.captionName = imageSetData.imageCaption; 
    this.line = imageSetData.line;
    this.class = imageSetData.class;
    this.modelNumber = imageSetData.identifier;
    this.highresimage = imageSetData.highResImage ? new ImageUploadImageModel(imageSetData.highResImage) : new ImageUploadImageModel();
    this.desktoplargeimage = imageSetData.deskTopLargeImage ? new ImageUploadImageModel(imageSetData.deskTopLargeImage) : new ImageUploadImageModel();
    this.desktopsmallimage = imageSetData.desktopSmallImage ? new ImageUploadImageModel(imageSetData.desktopSmallImage) : new ImageUploadImageModel();
    this.tabletimage = imageSetData.tabletImage ? new ImageUploadImageModel(imageSetData.tabletImage) : new ImageUploadImageModel();
    this.phoneimage = imageSetData.phoneImage ? new ImageUploadImageModel(imageSetData.phoneImage) : new ImageUploadImageModel();
    this.deskLargeResize = imageSetData.deskLargeResize;
    this.deskSmallResize = imageSetData.deskSmallResize;
    this.tabletResize = imageSetData.tabletResize;
    this.phoneResize = imageSetData.phoneResize;
  }
}



// WEBPACK FOOTER //
// ./src/app/image-admin/image-models/image-upload-image-set.model.ts